import { Component } from "@theme/component";
import { ThemeEvents, CartAddEvent } from "./events";
export class CustomAddToCart extends Component {
  connectedCallback() {
    this.querySelector("button")?.addEventListener("click", this.onClick);
  }

  onClick = async () => {
    const variantId = this.dataset.variantId;
    const qty = Number(this.dataset.qty ?? 1);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty }),
    });

    if (!res.ok) return;

    const data = await res.json();
    this.dispatchEvent(
      new CartAddEvent({}, this.id, {
        didError: true,
        source: "product-form-component",
        itemCount: 1,
        productId: this.dataset.productId,
        sections: data.sections,
      }),
    );
  };
}

customElements.define("custom-add-to-cart-component", CustomAddToCart);
